var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewpastreportbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16536 1.16699H3.4987C3.18928 1.16699 2.89253 1.28991 2.67374 1.5087C2.45495 1.72749 2.33203 2.02424 2.33203 2.33366V11.667C2.33203 11.9764 2.45495 12.2732 2.67374 12.4919C2.89253 12.7107 3.18928 12.8337 3.4987 12.8337H10.4987C10.8081 12.8337 11.1049 12.7107 11.3237 12.4919C11.5424 12.2732 11.6654 11.9764 11.6654 11.667V4.66699L8.16536 1.16699Z",
    stroke: "#004276",
    strokeWidth: 1.28333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 1.16699V4.66699H11.668",
    stroke: "#004276",
    strokeWidth: 1.28333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 7.58301H4.66797",
    stroke: "#004276",
    strokeWidth: 1.28333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 9.91699H4.66797",
    stroke: "#004276",
    strokeWidth: 1.28333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83464 5.25H5.2513H4.66797",
    stroke: "#004276",
    strokeWidth: 1.28333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewpastreportbutton);
export default __webpack_public_path__ + "static/media/view past report button.3a84e8034577fe2d9371b2d1aa71d473.svg";
export { ForwardRef as ReactComponent };